<template>
    <v-main>
        <v-layout fill-height column>
            <v-container flex-fill fluid>
                <div class="d-flex flex-column justify-center align-center flex-1 mb-10">
                    <img :src="getImage('ic_check.svg')" class="mb-5">
                    <div class="fs-18 blueGrayDarken4--text fw-700 line-height-1  mb-8">결제가 취소되었습니다.</div>
                </div>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="확인" @click="moveMainPage" />
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import { mixinAuth, mixinRemote } from '@/mixins'
import store from '@/store'
export default {
    data: () => ({
    }),
    components: {
        BlackBtn,
    },
    mixins: [ mixinAuth, mixinRemote ],
    async created(){
        await store.dispatch('getHeaderRealtalk')
    },
    methods:{
        moveMainPage(){
            this.movePage('/');
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.v-btn.btn-purchase-history {
    background: $color-sub;
    border-radius: 20px;
    color: $color-main;
    font-size: 16px;
    font-weight: 400;
    height: 30px;
    padding: 0 23px;
}
.purchase-info {
    border-radius: 10px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.11);
    padding: 26px 30px;
    .title {
        display: flex;
        align-items: center;
        font-size: 18px !important;
        font-weight: 700;
    }
    .badge {
        border: 1px solid $color-main;
        padding: 0 10px;
        height: 22px;
        font-size: 12px;
        font-weight: 500;
        color: $color-main;
        background: transparent;
        border-radius: 20px;
        width: auto;
        flex-shrink: 0;
    }
    .des {
        font-size: 14px;
        color: #BEBEBE;
        margin-top: 2px;
    }
}
</style>
